/*
 * newsbot - forked from autobrr
 */

import { classNames } from "@utils";
import { useDashboardStats } from "@api/queries";
import { StatsItem } from "@components/StatsItem";

export const Stats = () => {
  const { isLoading, isError, data } = useDashboardStats();

  if (isError) {
    return (
      <div className="text-center py-8 text-red-500 dark:text-red-400">
        Failed to load stats. Please refresh.
      </div>
    );
  }
  const gridClass = classNames(
    "grid grid-cols-2 gap-3 sm:gap-4 sm:grid-cols-4",
    isLoading ? "animate-pulse" : ""
  );
  const pipelineGridClass = classNames(
    "grid grid-cols-2 gap-3 sm:gap-4 sm:grid-cols-3 lg:grid-cols-5",
    isLoading ? "animate-pulse" : ""
  );

  return (
    <div>
      <h1 className="text-3xl font-bold text-black dark:text-white">Stats</h1>

      <dl className={classNames(gridClass, "mt-5")}>
        <StatsItem
          name="Stories created (24h)"
          to="/stories"
          value={data?.stories_last_24h}
          color="blue"
        />
        <StatsItem
          name="Extraction in progress"
          to="/settings/batches"
          value={data?.extraction_processing}
          color={data?.extraction_processing ? "yellow" : "default"}
        />
        <StatsItem
          name="Extraction failed"
          to="/settings/batches"
          value={data?.extraction_failed}
          color={data?.extraction_failed ? "red" : "default"}
        />
        <StatsItem
          name="Enabled feed failures"
          to="/settings/feeds"
          value={data?.feeds_with_errors}
          color={data?.feeds_with_errors ? "red" : "default"}
        />
      </dl>

      <h2 className="text-2xl font-bold text-black dark:text-white mt-8">Pipeline</h2>

      <dl className={classNames(pipelineGridClass, "mt-5")}>
        <StatsItem
          name="Ranked stories (24h)"
          to="/stories"
          value={data?.stories_ranked_last_24h}
          color="green"
        />
        <StatsItem
          name="Pending batches"
          to="/settings/batches"
          value={data?.batches_pending}
          color={data?.batches_pending ? "yellow" : "default"}
        />
        <StatsItem
          name="Completed batches (24h)"
          to="/settings/batches"
          value={data?.batches_completed_last_24h}
          color="blue"
        />
        <StatsItem
          name="Median batch duration (24h)"
          to="/settings/batches"
          value={data?.batch_median_duration_minutes == null ? "—" : `${data.batch_median_duration_minutes}m`}
        />
        <StatsItem
          name="P95 batch duration (24h)"
          to="/settings/batches"
          value={data?.batch_p95_duration_minutes == null ? "—" : `${data.batch_p95_duration_minutes}m`}
          color={
            data?.batch_p95_duration_minutes != null && data.batch_p95_duration_minutes > 60
              ? "red"
              : "default"
          }
        />
      </dl>
    </div>
  );
};
